export default "dist/furniture/spacebar.png";